import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchOrganizationMemberByIdArgs,
  FetchOrganizationMembersArgs,
} from '../api/types/organizationMembers.types';

import {
  fetchOrganizationMemberById,
  fetchOrganizationMembers,
} from '../api/organizationMembers.api';

export const organizationMembersQueryKeys = createQueryKeys(
  'organizationMembers',
  {
    fetchOrganizationMemberById: ({
      id,
      organizationId,
    }: FetchOrganizationMemberByIdArgs) => ({
      queryFn: () => fetchOrganizationMemberById({ id, organizationId }),
      queryKey: [organizationId, id],
    }),
    fetchInfiniteOrganizationMembers: ({
      filters,
      organizationId,
    }: FetchOrganizationMembersArgs) => ({
      queryFn: (context: { pageParam?: unknown }) =>
        fetchOrganizationMembers({
          filters: {
            ...filters,
            offset: (context?.pageParam as string) || '1',
            orderBy: filters?.orderBy || 'name',
          },
          organizationId,
        }),
      queryKey: [organizationId, filters],
    }),
    fetchOrganizationMembers: ({
      filters,
      organizationId,
    }: FetchOrganizationMembersArgs) => ({
      queryFn: () => fetchOrganizationMembers({ filters, organizationId }),
      queryKey: [organizationId, filters],
    }),
  },
);
